// src/components/SmartRedirect.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SmartRedirect = () => {
  const { token } = useAuth();

  return <Navigate to={token ? '/dashboard' : '/login'} replace />;
};

export default SmartRedirect;
